




















































































import { Vue, Ref, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { Item } from '@/api/paypal';
import { mask } from '@titou10/v-mask';
import { CreateStripeSessionRequest } from '@/api/stripe';
import StripeConfirmNoPay from '@/components/stripe/StripeConfirmNoPay.vue';

interface StripeObj {
  redirectToCheckout(opts: {sessionId: string}): void;
}

declare var Stripe: (key: string, opts: object) => StripeObj;

@Component({
  directives: {
    mask,
  },
  components: {
    StripeConfirmNoPay,
  },
})
export default class CheckoutStripe extends Vue {
  @Prop({type: Array, required: true}) public readonly items!: Item[];
  @Action('cart/createStripeSession') public readonly createSession!:
    (req: CreateStripeSessionRequest) => Promise<{id: string}>;
  @Action('tickets/validateGiftcard') public readonly validateCard!:
    (id: string) => Promise<Response>;
  @Ref('form') public form!: HTMLFormElement;

  public publishableKey = process.env.VUE_APP_STRIPE_PUBLISH_KEY || '';
  public stripeAccount = process.env.VUE_APP_STRIPE_ACCT || '';
  public stripe: StripeObj | null = null;
  public dialog = false;
  public valid = false;

  public final = false;

  private name = '';
  private email = '';
  private phone = '';
  private unmaskedPhone = '';
  private giftInput = '';

  private useGiftCard: {id: string, initial: string, balance: number} | null = null;
  private giftCardMessage = '';

  public async mounted() {
    await this.$loadScript('https://js.stripe.com/v3/');
    this.createButton();
  }

  public redeemedOk() {
    this.dialog = false;
    this.name = '';
    this.email = '';
    this.phone = '';
    this.unmaskedPhone = '';
    this.giftInput = '';
    this.useGiftCard = null;
    this.giftCardMessage = '';
    this.$emit('redeemed:success');
  }

  public get subtotal(): number {
    return this.items.reduce((total, curr) => {
        return total + Number(curr.unit_amount.value) * Number(curr.quantity);
      }, 0);
  }

  public createButton() {
    if (this.stripeAccount) {
      this.stripe = Stripe(this.publishableKey, {stripeAccount: this.stripeAccount});
    } else {
      this.stripe = Stripe(this.publishableKey, {});
    }
  }

  public async validateGiftCard(): Promise<boolean> {
    const resp = await this.validateCard(this.giftInput);
    if (resp.ok) {
      const giftcard = await resp.json();
      if (giftcard.balance <= 0) {
        this.giftCardMessage = `You have no balance on your giftcard left and thus cannot use it.`;
      // if (giftcard.balance > this.subtotal) {
        // this.giftCardMessage = `Purchase total must be greater than or equal to gift card total of $${giftcard.balance} to use.`;
      } else {
        this.useGiftCard = giftcard;
        return true;
      }
    } else {
      this.giftCardMessage = 'Gift Card Code not found!';
    }
    return false;
  }

  public async doCheckout() {
    if (!this.stripe) { return; }
    if (!this.form.validate()) { return; }
    if (this.useGiftCard === null && this.giftInput !== '') {
      if (!await this.validateGiftCard()) {
        return;
      }
    }

    if (this.useGiftCard !== null) {
      if (this.subtotal < this.useGiftCard.balance) {
        return;
      } else if (this.subtotal === this.useGiftCard.balance) {
        this.final = true;
        return;
      }
    }

    const sess = await this.createSession({
      useGift: this.useGiftCard !== null ? this.useGiftCard.id : '',
      items: this.items,
      name: this.name,
      email: this.email,
      phone: this.unmaskedPhone});
    this.stripe.redirectToCheckout({sessionId: sess.id});
  }
}
